/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    FETCH_AI_REVIEW_FAILURE,
    FETCH_AI_REVIEW_START,
    FETCH_AI_REVIEW_SUCCESS,
} from '../constants/types';

export const initialState = {
    loading: 0,
    error: null,
    data: {},
};

export function aiReview(state = initialState, action) {
    switch (action.type) {
        case FETCH_AI_REVIEW_START: {
            const { location_id, location_type } = action.payload;
            return {
                ...state,
                location_id,
                location_type,
                loading: state.loading + 1,
                error: null,
            };
        }
        case FETCH_AI_REVIEW_SUCCESS: {
            const data = action.payload.data ? action.payload.data : {};
            return {
                ...state,
                loading: Math.max(0, state.loading - 1),
                data,
            };
        }
        case FETCH_AI_REVIEW_FAILURE:
            return {
                ...state,
                loading: Math.max(0, state.loading - 1),
                error: action.payload.error,
            };
        default:
            return state;
    }
}

export const aiReviewSelector = (state) => state.ratingReviews.aiReview;
